import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import "./global.scss";
import {
  get,
  post,
  download,
  del,
  put,
  upload,
  uploadPut,
  uploadPost,
  downloadGet,
  printPdfPost
} from "./utils/request";
import piniaL from "./store/index.js";
import ElementPlus, { ElMessage } from "element-plus";
import "element-plus/dist/index.css";
import "swiper/css";
// import { setupI18n } from "./locales/setupI18n";
import directives from "./utils/directives";
import globalStore from "./store/global";
import * as ELIcons from "@element-plus/icons-vue";
import moment from "moment";
import print from "vue3-print-nb";
import "./assets/fonts/iconfont.css";
import dialogDrag from "./utils/dialogDrag.js";
import blurBottomFocus from "./utils/blurBottomFocus.js";
import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css'
import ContextMenu from '@imengyu/vue3-context-menu'
import i18n from '@/i18n/index.js'
 // ...纯表格
 import VxeTable from 'vxe-table'
import 'vxe-table/lib/style.css'
import VxeUI from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'
import vue3SeamlessScroll from "vue3-seamless-scroll";


const app = createApp(App);
for (let iconName in ELIcons) {
  app.component(iconName, ELIcons[iconName]);
}
app.config.globalProperties.$message = ElMessage;
app.config.globalProperties.$post = post;
app.config.globalProperties.$get = get;
app.config.globalProperties.$del = del;
app.config.globalProperties.$put = put;
app.config.globalProperties.$upload = upload;
app.config.globalProperties.$downloadGet = downloadGet;
// app.config.globalProperties.$downloadQTX = downloadQTX;

directives(app);
app.config.globalProperties.$uploadPut = uploadPut;
app.config.globalProperties.$uploadPost = uploadPost;
app.config.globalProperties.$download = download;
app.config.globalProperties.$printPdfPost = printPdfPost;
app.config.globalProperties.$toast = globalStore.showToast;

app.config.globalProperties.authorityShow = globalStore.authorityShow;
app.config.globalProperties.menusShow = globalStore.menusShow;
app.config.globalProperties.hAfterLeave = globalStore.hAfterLeave;
app.use(ElementPlus).use(router).mount("#app");
app.use(print);
app.use(moment);
app.use(piniaL);
app.use(ContextMenu);
// 版本太低 手动挂在 拖拽
app.use(dialogDrag);
app.use(blurBottomFocus);
app.use(VxeUI);
app.use(VxeTable);
app.use(i18n);
// app.use(VxeTable);
// app.use(VxeUI);
app.use(vue3SeamlessScroll);

